import { TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { TgbNativedescGeneralNarrow } from './components/TgbNativedescGeneralNarrow';
import { TgbNativedescGeneralWide } from './components/TgbNativedescGeneralWide';
import { getTgbNativedescGeneralNarrowProps } from './utils/getTgbNativedescGeneralNarrowProps';
import { getTgbNativedescGeneralWideProps } from './utils/getTgbNativedescGeneralWideProps';
import { selectVillage } from '../../../../../selectors/village';
import { getNewbuildingInfoForTgb } from '../../../../../services/getNewbuildingInfoForTgb';
import { INewbuildingInfoForTgbSchema } from '../../../../../types/adfox';
import { useApplicationContext } from '../../../../../utils/applicationContext';
import { useAdfoxContext } from '../../../external/context/AdfoxContext';

type TBehavior = 'wide' | 'narrow';

type TTgbNativedescGeneralContainerProps = {
  behavior: TBehavior;
  context: TTgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: React.FC<TTgbNativedescGeneralContainerProps> = ({ context, behavior }) => {
  const { httpApi } = useApplicationContext();
  const { newBuildingId, newBuildingIdIsUsed, useServerEnrichment, objectId, objectType, dealType } = context;
  const village = useSelector(selectVillage);

  const { sizes } = useAdfoxContext();

  /**
   * @description Нам не нужно хранить в сторе данные по баннеру,
   * так как страница сама по себе не перерисовывается с/без баннера + баннер нельзя закрыть и открыть
   */
  const [newbuidingInfoForTgb, setNewbuidingInfoForTgb] = React.useState<null | INewbuildingInfoForTgbSchema>(null);
  const isFetching = React.useRef(false);

  const newBuildingIdInt = newBuildingId ? parseInt(newBuildingId, 10) : null;
  const objectIdInt = objectId ? parseInt(objectId, 10) : newBuildingIdInt;

  /**
   * @description Только для значений newBuildingIdIsUsed === '1' и useServerEnrichment === '1' делаем запрос на бекенд для обогащения данных
   */
  const isEnrichmentFromBackendEnabled = newBuildingIdIsUsed === '1' || useServerEnrichment === '1';

  React.useEffect(() => {
    if (!isFetching.current && isEnrichmentFromBackendEnabled && objectIdInt && !newbuidingInfoForTgb) {
      isFetching.current = true;

      getNewbuildingInfoForTgb({
        httpApi,
        parameters: { objectId: objectIdInt, dealType, objectType },
      })
        .then(data => {
          if (!data.enrichments) {
            return;
          }

          setNewbuidingInfoForTgb(data.enrichments);
        })
        .finally(() => {
          isFetching.current = false;
        });
    }
    /**
     * @description Тут смотрим на изменение objectIdInt, изменение остальных данных не должно триггерить запрос
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectIdInt]);

  switch (behavior) {
    case 'narrow':
      return (
        <TgbNativedescGeneralNarrow {...getTgbNativedescGeneralNarrowProps({ context, newbuidingInfoForTgb, sizes })} />
      );
    case 'wide': {
      return (
        <TgbNativedescGeneralWide
          {...getTgbNativedescGeneralWideProps({ context, village, newbuidingInfoForTgb, sizes })}
        />
      );
    }
  }
};
